// extracted by mini-css-extract-plugin
export default {"container":"MyNetworkCard_container__OG-aO","counterItem":"MyNetworkCard_counterItem__SDhuB","count":"MyNetworkCard_count__+vuiL","label":"MyNetworkCard_label__RC838"};